// extracted by mini-css-extract-plugin
module.exports = {"cartButton":"ECouponProductCard_cartButton__R6Df2","brand":"ECouponProductCard_brand__fE1Kj","title":"ECouponProductCard_title__LGpEM"};